<template>
  <form @submit.prevent="validateData()"  method="POST" id="login" class="login100-form validate-form flex-sb flex-w">
    <div class="p-b-10">
      <label for="email" class="txt1">Email</label>
    </div>
    <div class="field wrap-input">
      <input class="is-shadowless input100" id="email" name="email" type="email" v-model="email" :placeholder="$t('login.emailPlaceholder')" required>
    </div>
    <div class="container-login100-form-btn">
      <button class="login100-form-btn">{{$t('recoveryPassword.actionButton')}}</button>
      <a @click="goTo('login')" class="txt2 m-l-5">{{$t('recoveryPassword.gobackLogin')}}</a>
    </div>
  </form>
</template>
<script>
import { xMisc } from '@/mixins/xMisc.js'
export default {
  name: 'recover-password',
  mixins: [xMisc],
  data () {
    return {
      email: null
    }
  },
  methods: {
    validateData () {
      console.log(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/client/RecoveryPassword.vue